import React from "react";
import { LoaderProvider } from "./widget/loader/LoaderContext";
export var NissanDependencies = function (_a) {
    var children = _a.children;
    return React.createElement(LoaderProvider, null, children);
};
